import { render, staticRenderFns } from "./DatasetsWithUnacceptedLicense.vue?vue&type=template&id=0731afd8&"
import script from "./DatasetsWithUnacceptedLicense.vue?vue&type=script&lang=js&"
export * from "./DatasetsWithUnacceptedLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports